import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, Message, SelectItem, TreeNode } from 'primeng/api';
import { Table } from 'primeng/table';
import { Contrato } from 'src/app/admihair/api/dto/contrato';
import { ContratoRateio } from 'src/app/admihair/api/dto/contrato-rateio';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ItemServico } from 'src/app/admihair/api/dto/item-servico';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { ProfissionalHabilidade } from 'src/app/admihair/api/dto/profissional-habilidade';
import { ContratoRateioService } from 'src/app/admihair/service/contrato-rateio.service';
import { ContratoService } from 'src/app/admihair/service/contrato.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { GrupoService } from 'src/app/admihair/service/grupo.service';
import { ProfissionalHabilidadeService } from 'src/app/admihair/service/profissional-habilidade.service';
import { ProfissionalService } from 'src/app/admihair/service/profissional.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { GrupoAgrupado } from 'src/app/admihair/api/dto/grupo-agrupado';
import { TreeTable } from 'primeng/treetable';

@Component({
  selector: 'app-profissional-editar',
  templateUrl: './profissional-editar.component.html',
  styleUrls: ['./profissional-editar.component.scss']
})
export class ProfissionalEditarComponent implements OnInit {

  permissaoEditar: boolean = false;
  messagemVisivel: boolean = false;
  messages: Message[] = [];
  messagemVisivelDialog: boolean = false;
  messagemDialog: Message[] = [];
  id?: number;
  empresaSelecionada?: Empresa;
  profissional?: Profissional;

  habilidades: ProfissionalHabilidade[] = [];
  contratos: Contrato[] = [];
  contratoSelecionado?: Contrato;

  tipos: SelectItem[] = [
    { label: 'COLABORADOR', value: 'COLABORADOR' },
    { label: 'PARCEIRO', value: 'PARCEIRO' }
  ];
  listaAgenda: SelectItem[] = [
    { label: 'S-Sim', value: 'S' },
    { label: 'N-Não', value: 'N' }
  ];

  listaRateios: ContratoRateio[] = [];
  exibirDialogServicos: boolean = false;

  progressoRequisicao: boolean = false;
  exibirSpinnerPrincipal: boolean = false;
  exibirSpinnerDialog: boolean = false;
  exibirSpinnerHabilidades: boolean = false;

  colunasTreeTableServicos: any[] = [];
  treeTableServicosDisponiveis: TreeNode[] = [];
  treeTableServicosDisponiveisSelecionado: TreeNode[] = [];

  horasServico: string[] = ['00', '01', '02', '03', '04', '05', '06'];
  minutosServico: string[] = ['00', '05', '10', '15', '20', '25', '30',
    '35', '40', '45', '50', '55'];

  listaHabilidadesSelecionadas: ProfissionalHabilidade[] = [];

  @ViewChild('f') form?: NgForm;
  @ViewChild('filter') filter!: ElementRef;
  value?: string;

  constructor(private utilStorageService: UtilStorageService,
    private profissionalService: ProfissionalService,
    private profissionalHabilidadeService: ProfissionalHabilidadeService,
    private contratoService: ContratoService,
    private contratoRaterioService: ContratoRateioService,
    private grupoService: GrupoService,
    private erroService: ErroService,
    private confirmationService: ConfirmationService,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.exibirSpinnerPrincipal = true;
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_PROFISSIONAL');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    this.carregarIdProfissional()
    if (this.permissaoEditar) {
      this.inicializarColunas();
      this.carregarProfissional();
    }
  }

  inicializarColunas() {
    this.colunasTreeTableServicos = [
      { field: 'descricao', header: 'Grupos de Serviços' }
    ];
  }

  carregarIdProfissional() {
    const idParam = this.activatedRoute.snapshot.paramMap.get('id');
    if (idParam) this.id = parseInt(idParam);
  }

  carregarProfissional() {
    this.profissionalService.buscarPorId(this.id).subscribe({
      next: (data: Profissional) => {
        this.profissional = data;
        this.buscarContratos();
      },
      error: (err: any) => {
        this.exibirSpinnerPrincipal = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    });
  }

  buscarContratos() {
    if(this.profissional?.tipo === 'COLABORADOR') {
      this.contratoService.listarPorEmpresaId(this.empresaSelecionada?.id).subscribe({
        next: (data: Contrato[]) => {
          this.contratos = data;
          this.carregarProfissionalHabilidades();
        },
        error: (err: any) => {
          this.exibirSpinnerPrincipal = false;
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
          this.rolarTela();
        }
      });
    } else if (this.profissional?.tipo === 'PARCEIRO') {
      const cpf = this.profissional.cpf;
      this.contratoService.listarPorEmpresaECpfProfissional(this.empresaSelecionada?.id, cpf).subscribe({
        next: (data: Contrato[]) => {
          this.contratos = data;
          this.carregarProfissionalHabilidades();
        },
        error: (err: any) => {
          this.exibirSpinnerPrincipal = false;
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
          this.rolarTela();
        }
      });
    }
  }

  recarregarContratos(){
    if(this.profissional?.tipo === 'COLABORADOR') {
      this.contratoService.listarPorEmpresaId(this.empresaSelecionada?.id).subscribe({
        next: (data: Contrato[]) => {
          this.contratos = data;
        },
        error: (err: any) => {
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
          this.rolarTela();
        }
      });
    } else if (this.profissional?.tipo === 'PARCEIRO') {
      const cpf = this.profissional.cpf;
      this.contratoService.listarPorEmpresaECpfProfissional(this.empresaSelecionada?.id, cpf).subscribe({
        next: (data: Contrato[]) => {
          this.contratos = data;
        },
        error: (err: any) => {
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
          this.rolarTela();
        }
      });
    }
  }

  carregarProfissionalHabilidades() {
    this.profissionalHabilidadeService.listarPorProfissionalId(this.profissional?.id).subscribe({
      next: (data: ProfissionalHabilidade[]) => {
        this.exibirSpinnerPrincipal = false;
        this.habilidades = data;
      },
      error: (err: any) => {
        this.exibirSpinnerPrincipal = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
  }

  atualizar() {
    this.progressoRequisicao = true;
    this.profissionalService.atualizar(this.id, this.profissional).subscribe({
      next: (data: Profissional) => {
        this.profissional = data;
        if(this.habilidades.length > 0){
          this.salvarHabilidades();
        } else {
          this.progressoRequisicao = false;
          this.messages = this.erroService.handleSuccess();
          this.messagemVisivel = true;
          this.rolarTela();
        }
        
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
  }

  salvarHabilidades() {
    this.profissionalHabilidadeService.salvarLista(this.habilidades).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.rolarTela();
        this.recarregarProfissionalHabilidades();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    })
  }

  recarregarProfissionalHabilidades() {
    this.exibirSpinnerHabilidades = true;
    this.profissionalHabilidadeService.listarPorProfissionalId(this.profissional?.id).subscribe({
      next: (data: ProfissionalHabilidade[]) => {
        this.exibirSpinnerHabilidades = false;
        this.habilidades = data;
      },
      error: (err: any) => {
        this.exibirSpinnerHabilidades = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    })
  }

  abrirDialogHabilidades() {
    this.carregarGruposAgrupados();
    this.exibirDialogServicos = true;
  }

  carregarGruposAgrupados() {
    this.exibirSpinnerDialog = true;
    let gruposAgrupados: GrupoAgrupado[] = [];
    const idContrato = this.profissional?.contrato?.id;
    const idProfissional = this.profissional?.id;

    this.grupoService.listarGruposSubgruposAgrupados(idContrato, idProfissional).subscribe({
      next: (data: GrupoAgrupado[]) => {
        gruposAgrupados = data;
        this.treeTableServicosDisponiveis = this.converterParaTreeNode(gruposAgrupados);
        this.carregarRateios();
      },
      error: (err: any) => {
        this.exibirSpinnerDialog = false;
        this.messagemDialog = this.erroService.handleErro(err);
        this.messagemVisivelDialog = true;
      }
    });
  }

  carregarRateios() {
    this.contratoRaterioService.listarPorContrato(this.profissional?.contrato?.id).subscribe({
      next: (data: ContratoRateio[]) => {
        this.exibirSpinnerDialog = false;
        this.listaRateios = data;
      },
      error: (err: any) => {
        this.exibirSpinnerDialog = false;
        this.messagemDialog = this.erroService.handleErro(err);
        this.messagemVisivelDialog = true;
      }
    })
  }

  adicionarHabilidadeDialog() {
    let itensServicos: ItemServico[] = [];
    for (const item of this.treeTableServicosDisponiveisSelecionado) {
      if (!item.children) {
        itensServicos.push(item.data)
      }
    }
    this.preencherHabilidade(itensServicos);
    this.exibirDialogServicos = false;

  }

  preencherHabilidade(lista: ItemServico[]) {
    for (const servico of lista) {
      for (const rateio of this.listaRateios) {
        if (servico.subgrupo?.id === rateio.subgrupo?.id) {
          let valorComissao = this.profissional?.tipo === 'PARCEIRO' ?
            100 : servico.comissaoVenda;

          const habilidade: ProfissionalHabilidade = {
            rateio: rateio.percentualRateio,
            profissional: this.profissional,
            itemServico: servico,
            comissao: valorComissao,
            valorFixo: 0.00,
            tempoMedio: servico.tempoMedio,
            tempoMedioHora: servico.tempoMedio?.split(':')[0],
            tempoMedioMinuto: servico.tempoMedio?.split(':')[1]
          }
          if (!this.habilidades.some(h => h.itemServico?.id === habilidade.itemServico?.id)) {
            this.habilidades.push(habilidade);
          }
        }
      }
    }
  }

  converterParaTreeNode(gruposAgrupados: GrupoAgrupado[]): TreeNode[] {
    return gruposAgrupados.map(grupo => ({
      data: grupo,
      children: grupo.subgrupos ? grupo.subgrupos.map(subgrupo => ({
        data: subgrupo,
        children: subgrupo.servicos ? subgrupo.servicos.map(servico => ({
          data: servico,
          leaf: true,
        })) : []
      })) : []
    }));
  }

  excluirHabilidade(item: ProfissionalHabilidade) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        if (item.id) {
          this.profissionalHabilidadeService.excluir(item.id).subscribe({
            next: () => {
              this.messages = this.erroService.handleSuccess();
              this.messagemVisivel = true;
              this.rolarTela();
              this.recarregarProfissionalHabilidades();
            },
            error: (err: any) => {
              this.messages = this.erroService.handleErro(err);
              this.messagemVisivel = true;
              this.rolarTela();
            }
          });
        } else {
          const posicao = this.habilidades.indexOf(item);
          this.habilidades.splice(posicao, 1);
        }
      }
    });
  }

  excluirTodasHabilidades() {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir todas?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {

        let listaIds: number[] = [];

        for (let item of this.listaHabilidadesSelecionadas) {
          if (item.id) {
            listaIds.push(item.id)
          } else {
            const posicao = this.habilidades.indexOf(item);
            this.habilidades.splice(posicao, 1);
            this.listaHabilidadesSelecionadas = [];
          }
        }

        if (listaIds.length > 0) {
          this.profissionalHabilidadeService.excluirHabilidadesPorId(listaIds).subscribe({
            next: () => {
              this.messages = this.erroService.handleSuccess();
              this.messagemVisivel = true;
              this.rolarTela();
              this.recarregarProfissionalHabilidades();
              this.listaHabilidadesSelecionadas = [];
            },
            error: (err: any) => {
              this.messages = this.erroService.handleErro(err);
              this.messagemVisivel = true;
              this.rolarTela();
            }
          });
        }
      }
    });

  }

  alterarComissao(indice: number) {
    if (this.profissional?.tipo === 'COLABORADOR') {
      this.habilidades[indice].comissao = 0;
    }
  }

  alterarValorFixo(indice: number) {
    if (this.profissional?.tipo === 'COLABORADOR') {
      this.habilidades[indice].valorFixo = 0;
    }
  }

  verificarPermissao(nome: string): boolean {
    return AuthUtil.verificarPermissao(nome);
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  buscarTree(table: TreeTable, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limparTree(table: TreeTable) {
    table.filterGlobal('', 'contains');
    this.filter.nativeElement.value = '';
  }

}